module.exports = __webpack_public_path__ + "img/project.867f23dc.png";